import { render, staticRenderFns } from "./OptionButtonBar.vue?vue&type=template&id=87e26128&scoped=true&"
import script from "./OptionButtonBar.vue?vue&type=script&lang=ts&"
export * from "./OptionButtonBar.vue?vue&type=script&lang=ts&"
import style0 from "./OptionButtonBar.vue?vue&type=style&index=0&id=87e26128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e26128",
  null
  
)

export default component.exports